import React from 'react';
import { BrandsAPI } from '../../../../../../constructs/brands/interface';
import { useAPIContext } from '../../../../context/api';
import { AnyCreativityConfig, CreativityType } from '../../../../types/banner';

export const useCreateFormBanner = () => {
  const { callEndpoint } = useAPIContext();

  const createFormBanner = React.useCallback(
    async (
      creativityType: CreativityType,
      creativityConfig: AnyCreativityConfig,
      title: string,
      templateFamily?: string
    ) => {
      try {
        const res = await callEndpoint<BrandsAPI, 'create-creativity-banner'>('brands', '/creativities', 'POST', {
          creativityType,
          creativityConfig,
          title,
          templateFamily
        });

        if (!res) throw new Error('Respuesta del servidor inesperada');

        return res;
      } catch (error: any) {
        console.error('Error al crear el banner:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { createFormBanner };
};
